// extracted by mini-css-extract-plugin
export default {"main":"PrivacyPolicyModule_main__RT1Fe","container":"PrivacyPolicyModule_container__zOCqA"};